// extracted by mini-css-extract-plugin
module.exports = {"collapsedArrowIcon":"Question_collapsedArrowIcon__2FaD9","expandedArrowIcon":"Question_expandedArrowIcon__E3sM3"};